export interface IQuestionsModel {
  question: string;
}

export interface IConvModel {
  value: string;
  time: string | Date;
  apiCheck?: boolean;
}

export interface IConversationModel {
  id: string;
  prompt: IConvModel;
  answer?: IConvModel;
  image?:any;
}

export interface ISummarizationModel {
  enableSummarization: boolean;
  knowledgebase_summarization: Function;
}

export interface ITemplateAttributesModel {
  description?: string;
  examples?: string[];
  id?: string;
  attributeId?: string;
}

export interface IExtractesDataModel {
  dataId: string,
  label: string,
  value: string,
  flags?: any,
  roles?: any,
  monitor?: boolean,
  workflows?: any,
}

// enums

export enum KB_NAMES_ENUM {
  KDB_NAME = "kdb_name",
  UNIQUE_KDB = "unique_kdb"
}

export enum MULTI_OPERATION_ENUM {
  INGEST_DOC_DB = "ingest_doc_db",
  COPY_DB = "copy_db",
  DELETE_DB = "delete_db",
  RENAME = "rename",
}

export enum DOC_AI_MODE_ENUM {
  SINGLE_DOCUMENT_MODE = 'single',
  MULTI_DOCUMENT_MODE = 'multi'
}

export enum PROCESSING_TABS {
  DOCUMENT = 'document',
  TEMPLATE = 'template',
  VALIDATION = 'validation',
  SUMMARIZATION = 'summarization',
  CROP = 'crop'
}

export enum SOLUTION_STUDIO_TABS {
  DASHBOARD = 'dashboard',
  DOCUMENT = 'document',
  TEMPLATE = 'template',
  VALIDATION = 'validation',
  SUMMARIZATION= 'summarization',
  CHATBOT='chatBot',
  CONFIGURE_PREFERENCES = 'configurePreferences',
}

export enum DATA_ANALYSIS_STUDIO_TABS {
  DASHBOARD = 'dashboard',
  DOCUMENT = 'document',
  ONTOLOGY= 'ontology',
  CHATBOT='chatBot',
  ONTOLOGY_GRAPH= 'ontologyGRAPH',
  CONFIGURE_PREFERENCES = 'configurePreferences',
  TEST_QUERY = 'test_query'
}

export enum EBOOK_INSIGHTS {
  DASHBOARD = 'dashboard',
  DOCUMENT = 'document',
  SUMMARIZATION= 'summarization',
  CHATBOT='chatBot',
  CONFIGURE_PREFERENCES = 'configurePreferences',
  TEST_QUERY = 'test_query'
}

export enum APIS_LIST {
  VALIDATION = 'validation',
  DATA_EXTRACTION = 'data_extraction',
  SUMMARIZATION = 'summarization',
  CHATBOT = 'chatbot',
  DOC_AI_UPLOAD_FILE = 'docai_upload_file'
}
